/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { FormGroup, FormLabel, Button, Form, TextInput } from 'carbon-components-react';
import { ComboBox } from '../../../helpers/ComboBox';
import DateTimePicker from '../../../helpers/DateTimePicker';
import { STATUS, DateFormat } from '../../../helpers/Constants';
import {api } from '../../../helpers/api/api';
import Close16 from '@carbon/icons-react/lib/close/16';
import {
  DropdownSkeleton,
} from 'carbon-components-react';

export default class DrillReportFilterModal extends Component {
  constructor(props) {
    super(props);
    this.defaultGuid = '00000000-0000-0000-0000-000000000000';
    this.weeks = [...Array(53).keys()].map((x) => x + 1 + '');
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.updateState = this.updateState.bind(this);
    this.statuses = STATUS;
    this.state = {
      isLoadingStatus : true,
      isLoadingEmergencyLevel : true,
      search: {
        drillEmergencyLevel: this.props.searchModel?.drillEmergencyLevel || null,
        status: this.props.searchModel?.status || null,

        idEmergencyLevel: this.props.searchModel?.idEmergencyLevel || this.defaultGuid,
        idStatus: this.props.searchModel?.idStatus || 0,

        code: this.props.searchModel?.code || null,
        dateOfOccurence: this.props.searchModel?.dateOfOccurence,

        compilerEmail: this.props.searchModel?.compilerEmail || null,
        dataApproverEmail: this.props.searchModel?.dataApproverEmail || null,
        divisionManagerEmail: this.props.searchModel?.divisionManagerEmail || null,
        isBack: this.props.checkBack,
      },
    };
  }

  componentDidMount(){
    this.getStatus();
  }


  getStatus = () => {
    api
      .getAll('/registry/status?page=0')
      .then((response) => {
        const { data } = response;
        const statusCopy = { ...this.state.search };
        statusCopy.status = data ;
        console.log(data);
        this.setState({
         search : statusCopy
        }, () =>  this.getEmergencyLevels());
      }).finally(() => {
        this.setState({
          isLoadingStatus: false,
        });
      });
  };

  getEmergencyLevels = () => {
    api
      .getAll('drill/emergencyLevel')
      .then((response) => {
        const { data } = response;
        const statusCopy = { ...this.state.search };
        statusCopy.drillEmergencyLevel = data ;
        console.log(data);
        this.setState({
         search : statusCopy,
        });
      }).finally(() => {
        this.setState({
          isLoadingEmergencyLevel: false,
        });
      });
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.isBack = false;
    // statusCopy['selectedItemCombo'][inputName] = selectedItem;
    this.setState(statusCopy);
  };


  handleChangeSearch = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'search');
  };

  handleSearch = (e) => {
    this.setState({isBack : false,
    search : {
      status : this.state.search.status.find((el)=> el.id == this.state.search.idStatus),
    }
    });
    this.updateState("isBack", false, 'search');
    this.props.onSearch(e, this.state.search);
  };

  handleCancel = (e) => {
    this.setState({isBack : false});
    this.updateState("isBack", false, 'search');
    this.props.onCancel(e, this.state.search);
  };

  handleClose = (e) => {
    this.setState({isBack : false});
    this.props.onClose(e, this.state.search);
  };
  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.isBack = false;
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };
  handleChangeCode = (el) => {
    const inputName = 'code';
    const inputValue = el.target.value;
    const objName = 'search';
    this.updateState(inputName, inputValue, objName);
  };
  render() {
    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container modal-container-custom">
          <div className="modal-header">
            <h3 className="bx--modal-header"> Filters </h3>
            <Button className="bx--modal-close" renderIcon={Close16} onClick={this.props.onClose} />
          </div>
          <Form autoComplete="off" onSubmit={this.handleClickSearch}>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-6">
                <FormGroup legendText="Status">
                      {this.state.isLoadingStatus ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchStatus"
                placeholder="All"
                name="idStatus"
                alt="search"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.reportingName : '')}
                initialSelectedItem={this.state.search.idStatus ? this.state.search.status.find((el)=> el.id == this.state.search.idStatus) : 
                  "ALL"
                }
                items={this.state.search.status?.filter(s => s.id != 3)}
              />
            )}
                </FormGroup>
              </div>

              <div className="bx--col-lg-6 bx--col-md-6">
                <FormGroup legendText="Emergency Level">
                                    {this.state.isLoadingEmergencyLevel ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idEmergencyLevel"
                placeholder="All"
                name="idEmergencyLevel"
                alt="search"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={this.state.search.idEmergencyLevel ? this.state.search.drillEmergencyLevel.find((el)=> el.id == this.state.search.idEmergencyLevel) : 
                  "ALL"
                }
                items={this.state.search.drillEmergencyLevel}
              />
            )}
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-6">
                <FormGroup legendText="Code">
                  <TextInput
                    id="CodeDrill"
                    name="code"
                    placeholder="Input Code"
                    value={this.state.search.code}
                    onChange={this.handleChangeCode}
                    type="text"
                    alt="searchModel"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-6">
                <FormGroup legendText="Effective Date">
                  <DateTimePicker
                    value={this.state.search?.dateOfOccurence}
                    type="date"
                    placeholder={DateFormat}
                    name="dateOfOccurence"
                    alt="search"
                    onChange={this.updateState}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel>Email Compiler</FormLabel>
                <TextInput
                  id="inputsearchcompiler"
                  name="compilerEmail"
                  value={this.state.search.compilerEmail}
                  onChange={this.handleChangeSearch}
                  placeholder="Input Compiler"
                  type="text"
                  labelText=""
                  className="bx--text-input some-class bx--text-input--light"
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel>Email Data Approver</FormLabel>
                <TextInput
                  id="inputsearchdataApprover"
                  name="dataApproverEmail"
                  value={this.state.search.dataApproverEmail}
                  onChange={this.handleChangeSearch}
                  placeholder="Input Data Approver"
                  type="text"
                  labelText=""
                  className="bx--text-input some-class bx--text-input--light"
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel>Email Consolidator</FormLabel>
                <TextInput
                  id="inputsearchdivisionManager"
                  name="divisionManagerEmail"
                  value={this.state.search.divisionManagerEmail}
                  onChange={this.handleChangeSearch}
                  placeholder="Input Consolidator"
                  type="text"
                  labelText=""
                  className="bx--text-input some-class bx--text-input--light"
                />
              </FormGroup>
            </div>
          </Form>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              size="small"
              kind="secondary"
              onClick={this.handleCancel}
            >
              Cancel
            </Button>
            <Button className="button--max-width" size="small" onClick={this.handleSearch}>
              Search
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
